module.exports = __webpack_public_path__ + "img/Open Link.079583bb.png";